import { render, staticRenderFns } from "./InvitationFriends.vue?vue&type=template&id=8491e498&scoped=true"
import script from "./InvitationFriends.vue?vue&type=script&lang=js"
export * from "./InvitationFriends.vue?vue&type=script&lang=js"
import style0 from "./InvitationFriends.vue?vue&type=style&index=0&id=8491e498&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8491e498",
  null
  
)

export default component.exports